import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Loading } from '@gtintel/signin/components/common/Loading';
import { AuthLayout } from '@gtintel/signin/components/layout/AuthLayout';

export const Redirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('url');

  useEffect(() => {
    if (redirectUrl) {
      // Validate the redirect URL against allowed domains
      // In production, this should check against a whitelist
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [redirectUrl]);

  return (
    <AuthLayout title="Redirecting...">
      <div className="text-center space-y-4">
        <Loading size="lg" />
        <p className="text-sm text-gray-600">You are being redirected to your application...</p>
        {redirectUrl && (
          <p className="text-xs text-gray-500">Destination: {new URL(redirectUrl).hostname}</p>
        )}
      </div>
    </AuthLayout>
  );
};
